import { FunctionComponent, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getUserData, setNewProfilePicture, updateUserName } from "../../../api/authApi";
import { changeUserPassword, changeUsername, updateProfilePicture, getProfilePicture } from "../../../api/usersApi";
import { Button } from "../../components/Button";
import { FormInput, FormRow, FormRowHorizontal, SelectOption } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import SelectFileButton, { SelectAvatarButton } from "../../components/selectFileButton/SelectFileButton";
import InnerLayout from "../innerLayout/InnerLayout";
import "./UserSettings.css"

interface UserSettingsProps extends RouteComponentProps<any>{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}
 
const UserSettings: FunctionComponent<UserSettingsProps> = (props : UserSettingsProps) => {
    let [isLoading, setIsloading] = useState(false);
    let [newPassword, setNewPassword] = useState<string>("");
    let [newPasswordError, setNewPasswordError] = useState<boolean>(false);

    let [confrimPassword, setConfirmPassword] = useState<string>("");
    let [confirmPasswordError, setConfirmPasswordError] = useState<boolean>(false);

    let [newUsername, setNewUsername] = useState<string>("");
    let [newUsernameError, setNewUsernameError] = useState<boolean>(false);

    let [userAvatar, setUserProfilePicture] = useState<string>(getUserData().profilePicture);

    const changePassword = async () =>{
        let isError = true;
        if(newPassword === "" || newPassword.length < 8){
            setNewPasswordError(true);
            isError = false;
        }
        if(confrimPassword === "" ){
            setConfirmPasswordError(true);
            isError = false;
        }
        if(newPassword !== confrimPassword){
            setNewPasswordError(true);
            setConfirmPasswordError(true);
            isError = false;
        }

        if(!isError) return;
        setIsloading(true);
        var result = await changeUserPassword({ password: newPassword});
        if(result.type == "succes"){
            alert("Password changed successfully");
        }
        setIsloading(false);
    }

    const changeUserNickname = async () =>{
        let isError = true;
        if(newUsername === ""){
            setNewUsernameError(true);
            isError = false;
        }

        if(!isError) return;

        setIsloading(true);
        var result = await changeUsername({username: newUsername});
        if(result.type == "succes"){
            updateUserName(newUsername);
            alert("Username changed successfully");
        }
        setIsloading(false);
    }

    const onUploadProfilePicture = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.files){
            const formData = new FormData();
            formData.append("Image", event.target.files[0]);
            await updateProfilePicture(formData); 
            var profileImageResult = await getProfilePicture();

            if(profileImageResult.type == "succes"){
                setNewProfilePicture(profileImageResult.data.data);
                setUserProfilePicture(profileImageResult.data.data);
                alert("Profile Picture Updated successfully");
            }
        };

    }

    const goBack = () => {
        props.history.goBack();
    }

    return (  
    <InnerLayout 
        isCollapsed={props.isCollapsed}
        logOut={props.logOut}
        toogleCollapse={props.toogleCollapse}
        activeTab="userSettings">
            <>
                <div className="user-settings-block">
                    <h2 className="settings-title">User settings</h2>
                    <label>Password</label>
                    <div className="double-row">
                    <FormRow>
                            <FormInput 
                                id="new-password"
                                title="New password"
                                isError={newPasswordError}
                                type="password"
                                errorMessage="Password should be 8 symbols long minimum"
                                onChange={e => { setNewPassword(e.target.value); setNewPasswordError(false);}}
                                value={newPassword}
                            />
                    </FormRow>
                    <FormRow>
                            <FormInput 
                                id="confirm-password"
                                title="Confirm password"
                                type="password"
                                isError={confirmPasswordError}
                                errorMessage="Password do not match"
                                onChange={e => { setConfirmPassword(e.target.value); setConfirmPasswordError(false);}}
                                value={confrimPassword}
                            />
                    </FormRow>
                    </div>
                    <FormRow>
                        <label> &nbsp;</label>
                        <Button color="green" label="Change Password" onClick={changePassword}/>
                    </FormRow>

                    <label>Username</label>
                    <FormRow>
                        <FormInput 
                            id="new-name"
                            title="New name"
                            isError={newUsernameError}
                            type="text"
                            errorMessage="Please enter new user name"
                            onChange={e => { setNewUsername(e.target.value); setNewUsernameError(false);}}
                            value={newUsername}
                        />
                    </FormRow>
                    <FormRow>
                        <label> &nbsp;</label>
                        <Button color="green" label="Change Username" onClick={changeUserNickname}/>
                    </FormRow>
                    <label>Profile Picture</label>
                    <FormRowHorizontal>
                        {userAvatar &&  
                        <label className="avatar">
                            <img className="avatar-img" src={userAvatar} alt="" />
                        </label>}  
                        <SelectAvatarButton title="Upload New Profile Picture" id="upload-new-profile-picture" onChange={(e)=>{onUploadProfilePicture(e)}}/>
                    </FormRowHorizontal>
                    
                    <div className="modal-btn-group">
                        <Button color="gray" label="Back" onClick={goBack}/>
                    </div>
                </div>
                <GlobalSpinner isShow={isLoading} />
            </>
    </InnerLayout> );
}
 
export default withRouter(UserSettings);